import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import type { Calendar } from 'owa-calendar-cache';
import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';
import { removeCalendar } from '../actions/removeCalendar';

export const removeCalendarMutator = mutator(removeCalendar, actionMessage => {
    const { calendar } = actionMessage;
    const store = getStore();
    const filterToFindCalendar = (item: Calendar) => {
        return (
            item.id.id === calendar.id.id &&
            item.id.mailboxInfo.userIdentity === calendar.id.mailboxInfo.userIdentity
        );
    };
    const calendarIndexToRemove = findInArray(store.calendars, filterToFindCalendar);

    if (calendarIndexToRemove && calendarIndexToRemove.index >= 0) {
        store.calendars.splice(calendarIndexToRemove.index, 1);
    }

    const selectedCalendarIndexToRemove = findInArray(
        store.selectedCalendars,
        filterToFindCalendar
    );

    if (selectedCalendarIndexToRemove && selectedCalendarIndexToRemove.index >= 0) {
        store.selectedCalendars.splice(selectedCalendarIndexToRemove.index, 1);
    }

    store.calendarLoadingState.delete(calendar.id.id);
    store.localLieCalendarIds.delete(calendar.id.id);
});
